import { Spinner } from './Spinner';
import { LoaderContainerStyled } from "./styled/LoaderStyled";

export const Loader = ({bg, show, size}) =>
    show ? (
        <LoaderContainerStyled bg={bg}>
            <Spinner size={size}/>
        </LoaderContainerStyled>
    ) : null;
